import _default from './MountNode';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/MountNode/index.js
// module id = 701
// module chunks = 1